if (!customElements.get('jc-hero-description')) {
  customElements.define(
    'jc-hero-description',
    class JCHeroDescription extends HTMLElement {
      connectedCallback() {
        this.rest = this.querySelector('.jc-hero__description-rest');
        this.toggle = this.querySelector('.jc-hero__description-toggle');
        this.label = this.toggle?.querySelector('.jc-btn__label');
        if (!this.rest || !this.toggle) return;

        this.toggle.setAttribute('aria-expanded', 'false');
        this.toggle.addEventListener('click', this.toggleDescription.bind(this));
      }

      toggleDescription() {
        const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
        this.rest.classList.toggle('hidden', expanded);
        this.toggle.setAttribute('aria-expanded', String(!expanded));
        if (this.label) {
          this.label.textContent = expanded ? 'Voir plus' : 'Voir moins';
        }
      }
    }
  );
}
